/**
 * Внутренний путь и ничего кроме: начинается со слэша, но НЕ с `//` и не с `/\`.
 *
 * `//evil.com` — это не путь, а protocol-relative URL: браузер прочитает его как
 * `https://evil.com`. Обратный слэш добавлен потому, что часть парсеров URL нормализует
 * `/\evil.com` в то же самое.
 */
const INTERNAL_PATH = /^\/(?![/\\])/

/**
 * Пропускает только внутренний путь. Всё остальное — `undefined`.
 *
 * Одна проверка на всё приложение, потому что потребителей у неё уже двое и оба опасные:
 *
 *   1. `?redirect=` на странице входа (`app/router/search.ts`). Значение уезжает в
 *      `/api/auth/login?redirect_uri=…`, и gateway отправляет туда браузер ПОСЛЕ успешной
 *      авторизации. Без фильтра ссылка `?redirect=https://evil.com` авторизует жертву у нас
 *      и высаживает на чужой странице — с полным доверием к процессу, который она только что
 *      сама и прошла.
 *   2. `Notification.href` (`entities/notification/ui/NotificationRow`). Контракт обещает
 *      внутренний путь, но обещание надо проверять: адрес приходит с сервера, а абсолютный
 *      URL в `navigate({ href })` роутер выполнит как `window.location.href = …` — полный уход
 *      из приложения.
 *
 * Держать две отдельные проверки нельзя: они разъедутся, и разъедется та, о которой забудут.
 *
 * `javascript:` и `data:` отсекаются тем же правилом — они не начинаются со слэша.
 */
export function internalPath(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  return INTERNAL_PATH.test(value) ? value : undefined
}
